import { render, staticRenderFns } from "./AttributeSelector.vue?vue&type=template&id=c0c4b6e0&scoped=true&"
import script from "./AttributeSelector.vue?vue&type=script&lang=js&"
export * from "./AttributeSelector.vue?vue&type=script&lang=js&"
import style0 from "./AttributeSelector.vue?vue&type=style&index=0&id=c0c4b6e0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c4b6e0",
  null
  
)

export default component.exports